module.exports = __webpack_public_path__ + "static/yhmnin-fafa982452ea23295af3bd00e0e040b6.png";